module.exports = __webpack_public_path__ + "static/img/references8.fc0057c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/references8.jpg
// module id = ln/A
// module chunks = 1